import React, { memo } from 'react';
import { Button } from 'appkit-react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import alert from '@components/alert';
import { QUESTION_STATUS } from '@model';

const hasCompletedSection = (status) => {
  let result = false;
  for (const value of Object.values(status)) {
    if (
      value.filter(
        (a) =>
          a !== QUESTION_STATUS.Finish && a !== QUESTION_STATUS.NotApplicable,
      ).length === 0
    ) {
      result = true;
      break;
    }
  }
  return result;
};

function ActionButtons({ steps }) {
  const { status } = useSelector(({ question }) => ({
    status: question.status,
  }));

  const history = useHistory();

  const currentSection = history.location.pathname.split('/')[2];

  const isCurrentSectionAllNotFinished =
    status[currentSection].filter((a) => a !== QUESTION_STATUS.Finish)
      .length === status[currentSection].length;

  const {
    isFirst,
    isLast,
    isActionLoading,
    isFetchLoading,
    preStepAndSave,
    answerLater,
    nextStepAndSave,
    currentAnswer,
  } = steps;

  const lastQuestionValid =
    [QUESTION_STATUS.Finish, QUESTION_STATUS.NotApplicable].includes(
      status[currentSection][status[currentSection].length - 1],
    ) || currentAnswer;
  const buttonEnabled =
    !isLast ||
    hasCompletedSection(status) ||
    // total.filter((a) => a !== 2).length === 0 ||
    (isLast &&
      status[currentSection].filter(
        (a) =>
          a !== QUESTION_STATUS.Finish && a !== QUESTION_STATUS.NotApplicable,
      ).length === 1 &&
      lastQuestionValid);

  const isNotApplicable =
    steps.allStatus &&
    steps.allStatus[steps.sequence] === QUESTION_STATUS.NotApplicable;

  return (
    <div className="questionnaires-action-wrapper">
      {isFirst ? (
        <div />
      ) : (
        <div className="action" onClick={preStepAndSave}>
          <span className="appkiticon icon-left-chevron-fill a-font-12" />
          Back
        </div>
      )}
      <div className="right">
        {!isLast && (
          <div
            className={`action ${isNotApplicable ? 'not-applicable' : ''}`}
            onClick={isNotApplicable ? undefined : answerLater}
          >
            Answer Later
          </div>
        )}
        <Button
          disabled={!buttonEnabled}
          isLoading={isActionLoading || isFetchLoading}
          onClick={nextStepAndSave}
          size="xl"
        >
          {isLast ? 'Review Response' : 'Next'}
        </Button>
        <div className="reset-button-area">
          <Button
            kind="secondary"
            size="lg"
            disabled={isCurrentSectionAllNotFinished}
            onClick={() => {
              alert.confirm({
                content:
                  'Please note the section will be reset with all question answers removed.',
                okText: 'ok',
                onOk: () => {
                  steps.resetSection();
                },
              });
            }}
          >
            Reset Section
          </Button>
        </div>
      </div>
    </div>
  );
}

const shouldUpdate = (previousProps, nextProps) => {
  // const {
  //   steps: {
  //     sequence: oldSeq,
  //     isActionLoading: oldLoading,
  //     isFirst: oldIsFirst,
  //     isLast: oldIsLast,
  //     currentSection: oldSection,
  //     allStatus: oldAllStatus,
  //     currentAnswer: oldAnswer,
  //   },
  // } = preProps;
  // const {
  //   steps: {
  //     sequence: newSeq,
  //     isActionLoading: newLoading,
  //     isFirst: newIsFirst,
  //     isLast: newIsLast,
  //     currentSection: newSection,
  //     allStatus: newAllStatus,
  //     currentAnswer: newAnswer,
  //   },
  // } = nextProps;
  //
  // return (
  //   oldSeq === newSeq &&
  //   oldLoading === newLoading &&
  //   oldIsFirst === newIsFirst &&
  //   oldIsLast === newIsLast &&
  //   oldSection === newSection &&
  //   oldAllStatus === newAllStatus &&
  //   oldAnswer === newAnswer
  // );

  const compareKeys = [
    'sequence',
    'isActionLoading',
    'isFetchLoading',
    'isFirst',
    'isLast',
    'currentSection',
    'allStatus',
    'currentAnswer',
  ];
  return compareKeys.every(
    (key) => previousProps?.steps[key] === nextProps?.steps[key],
  );
};

export default memo(ActionButtons, shouldUpdate);
